<template>
  <div class="container">
    <v-card-title class="toolbar blue">
      <span class="headline white--text">Email Template Types</span>
      <v-spacer />
      <v-text-field
        v-model="search"
        dark
        append-icon="search"
        label="Search"
        single-line
        hide-details
      />
    </v-card-title>

    <v-card-text class="white">
      <v-container>
        <v-layout class="btnWrapper">
          <v-btn @click="showModal('categories')">
            # Categories
          </v-btn>

          <v-btn @click="showModal('edit')">
            + Add Template Type
          </v-btn>
          <v-spacer />
        </v-layout>

        <v-data-table
          :headers="headers"
          :items="templateTypes"
          :rows-per-page-items="rowsPerPageItems"
          :pagination.sync="pagination"
          :search="search"
          @update:pagination="updatePagination"
        >
          <template
            slot="items"
            slot-scope="props"
          >
            <td>{{ props.item.id }}</td>
            <td class="text-xs">
              {{ props.item.name }}
            </td>
            <td class="text-xs">
              {{ props.item.templateId }}
            </td>
            <td class="text-xs">
              <div v-if="props.item.categories">
                <v-chip
                  v-for="category in props.item.categories"
                  :key="category"
                  :color="'green'"
                  outline
                >
                  {{ category }}
                </v-chip>
              </div>
            </td>
            <td class="text-xs-right">
              <v-btn
                color="blue"
                flat
                icon
                @click="showModal('edit', props.item.id)"
              >
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn
                color="blue"
                flat
                icon
                @click="showModal('delete', props.item.id)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-container>
    </v-card-text>

    <v-dialog
      v-model="categoriesModalOpen"
      width="400"
      persistent
    >
      <v-card>
        <v-form>
          <v-card-title
            class="headline grey lighten-2"
            primary-title
          >
            # Categories
            <v-spacer />

            <span v-if="loading">
              <v-progress-circular
                indeterminate
                color="primary"
                :size="24"
              />
            </span>
          </v-card-title>
          <v-card-title
            class="headline white lighten-2"
            primary-title
          >
            <v-text-field
              v-model="newEmailCategory.category"
              label="Category name"
            />
            <v-btn
              flat
              icon
              color="blue"
              @click="_createEmailCategory(newEmailCategory)"
            >
              <v-icon>check</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider />
          <v-list>
            <v-list-tile
              v-for="item in emailCategories"
              :key="item.id"
              avatar
            >
              <v-list-tile-content>
                <v-list-tile-title
                  v-if="!showEditCategory(item)"
                  v-text="item.category"
                />
                <v-text-field
                  v-if="showEditCategory(item)"
                  v-model="activeEmailCategory.category"
                  label="Category name"
                  :rules="nameRules"
                  required
                />
              </v-list-tile-content>

              <v-list-tile-action v-if="!showEditCategory(item)">
                <v-btn
                  flat
                  icon
                  color="blue"
                  @click="editCategory(item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-list-tile-action>
              <v-list-tile-action v-if="showEditCategory(item)">
                <v-btn
                  flat
                  icon
                  color="blue"
                  @click="saveCategory(item)"
                >
                  <v-icon>check</v-icon>
                </v-btn>
              </v-list-tile-action>
              <v-list-tile-action>
                <v-btn
                  flat
                  icon
                  color="blue"
                  @click="deleteEmailCategory(item)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <v-card-actions>
            <v-spacer />
            <v-btn
              flat
              @click="showModal('categories', null, false)"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="editModalOpen"
      width="400"
      persistent
    >
      <v-card>
        <v-form
          ref="templateForm"
          @submit.prevent="save"
        >
          <v-card-title
            class="headline grey lighten-2"
            primary-title
          >
            {{ mode === 'edit' ? 'Edit' : 'Create' }} Template Type Type
          </v-card-title>

          <v-card-text>
            <v-text-field
              v-model="activeTemplateType.name"
              label="Template Type Name"
              :rules="nameRules"
              required
            />
          </v-card-text>
          <v-card-text>
            <v-select
              v-model="activeTemplateType.categories"
              :items="emailCategories"
              :item-text="'category'"
              :item-value="'category'"
              :chips="true"
              :multiple="true"
              label="Categories"
            />
          </v-card-text>
          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn
              flat
              @click="showModal('edit', null, false)"
            >
              Close
            </v-btn>
            <e-button
              flat
              type="submit"
              color="blue"
              :text="mode === 'edit' ? 'Edit' : 'Create'"
              :loading="loading"
            />
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteModalOpen"
      width="400"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Delete Template Type
        </v-card-title>

        <v-card-text>
          Do you want to delete {{ activeTemplateType.name }} Template Type?
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            flat
            @click="showModal('delete', null, false)"
          >
            Close
          </v-btn>
          <e-button
            flat
            color="blue"
            text="Delete"
            :loading="loading"
            @click="deleteActiveItem"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import _ from 'lodash';
import { Button } from '@/components/shared';
import { setQuery } from '@/helpers';

export default {
  name: 'TemplateTypes',

  components: {
    'e-button': Button,
  },

  data() {
    return {
      mode: 'create',
      categoriesModalOpen: false,
      editModalOpen: false,
      deleteModalOpen: false,
      activeId: null,
      activeTemplateType: {},
      activeEmailCategory: {},
      newEmailCategory: {},
      search: '',
      headers: [
        { text: 'ID', value: 'id', sortable: true },
        { text: 'Name', value: 'name' },
        { text: 'Template ID', value: 'templateId' },
        { text: 'Categories', value: 'categories' },
        { text: 'Actions', value: 'actions' },
      ],
      rowsPerPageItems: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: 'All', value: -1 },
      ],
      pagination: {
        page: 1,
        rowsPerPage: 5,
      },
      isLoadTableData: false,
      nameRules: [v => !!v || 'Name is required'],
    };
  },

  computed: {
    ...mapState({
      templateTypes: state => state.templateTypeStore.templateTypes,
      emailCategories: state => state.templateTypeStore.emailCategories,
      loading: state => state.templateStore.loading,
    }),
    templateTypeIds() {
      return this.templateTypes ? this.templateTypes.map(v => v.id) : [];
    },
  },

  watch: {
    loading(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.editModalOpen = false;
        this.deleteModalOpen = false;
        this.activeId = null;
        this.activeTemplateType = {};
      }
    },
    pagination: {
      handler() {
        this.isLoadTableData = true;
      },
    },
  },

  async mounted() {
    this.getTemplateTypes();
    await this.$nextTick();
    this.changePage();
    this.getEmailCategories();
  },

  methods: {
    ...mapActions([
      'getTemplateTypes',
      'createTemplateType',
      'updateTemplateType',
      'deleteTemplateType',
      'getEmailCategories',
      'deleteEmailCategory',
      'updateEmailCategory',
      'createEmailCategory',
    ]),
    showEditCategory(item) {
      return this.activeEmailCategory && this.activeEmailCategory.category != null &&
        this.activeEmailCategory.category === item.category;
    },
    editCategory(category) {
      this.activeEmailCategory = category;
    },
    async saveCategory(item) {
      await this.updateEmailCategory(item);
      this.activeEmailCategory = {};
    },
    async _createEmailCategory(item) {
      await this.createEmailCategory(item);
      this.newEmailCategory = {};
    },
    save() {
      const isValid = this.$refs.templateForm.validate();

      if (isValid) {
        const validFields = [
          'id', 'name', 'categories',
        ];
        const payload = _.pick(this.activeTemplateType, validFields);

        if (this.mode === 'create') {
          this.createTemplateType(payload);
        }
        if (this.mode === 'edit') {
          this.updateTemplateType(payload);
        }
      }
    },
    showModal(type, id, open = true) {
      if (type !== 'delete') {
        this.activeId = id;
        this.mode = 'create';
        this[`${type}ModalOpen`] = open;
        this.activeTemplateType = _.find(this.templateTypes, { id }) || {};

        if (id) {
          this.mode = 'edit';
        }
      } else {
        this.activeId = id;
        this.activeTemplateType = {};
        this[`${type}ModalOpen`] = open;
      }
    },

    deleteActiveItem() {
      this.deleteTemplateType(this.activeId);
      this.activeId = null;
    },
    updatePagination(pagination) {
      if (this.isLoadTableData) {
        setQuery({ page: pagination.page }, this.$route, this.$router);
      }
    },
    changePage() {
      const { page } = this.$route.query;
      this.pagination.page = page ? Number(page) : 1;
    },
  },
};
</script>

<style lang="scss">
.justfifyEnd {
  display: flex;
  justify-content: flex-end;
}
.btnWrapper {
  justify-content: flex-end;
  display: flex;
  flex-direction: row-reverse;
}
.noneDecoration {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/views/templateTypes/TemplateTypes.vue